// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__Zqq0f","productName":"Table_productName__2BtIc"};